var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"px-2"},'div',_vm.$attrs,false),[_c('v-toolbar',{staticStyle:{"position":"sticky","top":"62px","margin-bottom":"8px","transform":"scale(1.02)","z-index":"3"},attrs:{"elevation":"2"}},[_c('v-toolbar-title',[_vm._t("title")],2),_c('v-spacer'),_vm._t("actions")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }